import { UK_ROUTES_NEW } from "constants/routes-new";

import { useContext, useEffect, useState } from "react";

import { Col, Divider, Flex, Menu, Row } from "antd";
import { AppContext } from "App";
import employmentTaxCalculator from "assets/images/employment-tax-calculator.svg";
import burgerIcon from "assets/images/header/menu-alt-2.svg";
import menuChevronDown from "assets/images/menu-chevron-down.svg";
import menuChevronUp from "assets/images/menu-chevron-up.svg";
import mtdMain from "assets/images/mtd-main.png";
import britainFlag from "assets/images/regions/united-kingdom.svg";
import selfEmploymentTaxCalculator from "assets/images/self-employment-tax-calculator.svg";
import logoSmall from "assets/images/taxzap-logo-r-small.png";
import taxzapLogo from "assets/images/taxzap-logo-R.svg";
import CountrySelect from "components/modals/CountrySelect";
import { useUser } from "hooks/common/useUser";
import { useLocalStorage } from "hooks/helpers/useLocalStorage";
import { useModalOpener } from "hooks/helpers/useModalOpener";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useNavigate, Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { scrollToTop } from "utils/common";
import { logError } from "utils/sentry";

const Header = () => {
    const navigate = useNavigate();
    const { user } = useUser();
    const [country, setCountry] = useLocalStorage<string | null>("country", null);

    const { isEmploymentTaxCalculatorEnabled, isSelfEmploymentTaxCalculatorEnabled } = useFlags();

    const {
        isMobile,
        isAuth,
        maxWidth,
    } = useContext(AppContext);

    const {
        isOpened: isCountrySelectorOpened,
        open: handleOpenCountrySelect,
        close: handleCloseCountrySelect,
    } = useModalOpener();

    const [isTaxCalcOpen, setIsTaxCalcOpen] = useState(false);
    const [isMobileTaxOpen, setIsMobileTaxOpen] = useState(false);

    useEffect(() => {
        const getLocation = async () => {
            try {
                if (!country) {
                    const response = await fetch("https://us1.api-bdc.net/data/reverse-geocode-client");
                    const body = await response.json();
                    if (body && body.countryName === "Ireland") {
                        handleOpenCountrySelect();
                    }
                    setCountry(body.countryName);
                }
            } catch (error: any) {
                const contextInfo = {
                    userId: user?.id,
                    function: "clarityIdentify",
                    error: error.message,
                };
                logError(error, contextInfo);
            }
        };
        getLocation();
    }, [country, handleOpenCountrySelect, setCountry, user?.id]);

    return <div className={"header__wrapper horizontal-center"}>
        <div style={{ maxWidth: maxWidth, width: "100%" }}>
            <Row className="header__row">
                <Col
                    xs={{ span: 14, order: 2 }}
                    xl={{ span: 4, order: 1 }}
                    className={"center"}
                >
                    <img
                        className="logo"
                        src={taxzapLogo}
                        alt="TaxZap Logo"
                        onClick={() => {
                            navigate("/");
                            scrollToTop();
                        }}
                    />
                </Col>
                <Col
                    xs={{ span: 4, order: 1 }}
                    lg={{ span: 3, order: 1 }}
                    xl={{ span: 13, order: 2 }}
                    className={"horizontal-left"}
                >
                    <Menu
                        theme="light"
                        mode="horizontal"
                        className={"horizontal-left header__menu-wrapper"}
                        overflowedIndicator={
                            <div
                                style={{
                                    display: "flex",
                                    alignContent: "center",
                                }}
                            >
                                <img
                                    height={24}
                                    width={24}
                                    src={burgerIcon}
                                    alt="burger"
                                />
                            </div>
                        }
                        style={{
                            border: "100px",
                            minWidth: 0,
                            flex: "auto",
                        }}
                    >
                        <Menu.Item key="how-it-works" className="header__menu-item-wrapper">
                            <HashLink smooth to={UK_ROUTES_NEW.howItWorks} className="header__menu-item">
                                How it Works
                            </HashLink>
                        </Menu.Item>

                        <Menu.Item key="why-taxzap" className="header__menu-item-wrapper">
                            <HashLink smooth to={UK_ROUTES_NEW.whyTaxzap} className="header__menu-item">
                                Why TaxZap
                            </HashLink>
                        </Menu.Item>
                        {isMobile
                            ? <>
                                <div onClick={() => setIsMobileTaxOpen(prev => !prev)}>
                                    <Menu.Item
                                        key="tax-calculator-title"
                                        disabled={true}
                                        className="header__menu-item header__menu-item-wrapper"
                                    >
                                        <div className="space-between">
                                            <div style={{ color: "black" }}>Resources</div>
                                            <img
                                                src={isMobileTaxOpen ? menuChevronUp : menuChevronDown}
                                                alt="chevron"
                                                style={{ display: "block" }}
                                            />
                                        </div>
                                    </Menu.Item>
                                </div>

                                {isMobileTaxOpen && (<>
                                    {isSelfEmploymentTaxCalculatorEnabled && (
                                        <Menu.Item key="tax-calculator-self" className="header__menu-item-wrapper">
                                            <HashLink smooth to={"/"} className="header__menu-item ml20">
                                            Self-employment Tax Calculator
                                            </HashLink>
                                        </Menu.Item>
                                    )}
                                    {isEmploymentTaxCalculatorEnabled && (
                                        <Menu.Item key="tax-calculator-employment" className="header__menu-item-wrapper">
                                            <HashLink smooth to={"/"} className="header__menu-item ml20">
                                            Employment Tax Calculator
                                            </HashLink>
                                        </Menu.Item>
                                    )}
                                    <Menu.Item key="tax-calculator-mtd" className="header__menu-item-wrapper" style={{ height: "auto" }}>
                                        <div
                                            className="header__desktop-taxcalc-submenu__content__right__mtd"
                                            onClick={() => {
                                                setIsMobileTaxOpen(false);
                                                navigate(UK_ROUTES_NEW.resources);
                                            }}
                                        >
                                            <div className="header__desktop-taxcalc-submenu__content__right__mtd__title">
                                                Make Tax Digital (MTD) Requirement Checker
                                            </div>
                                            <div className="header__desktop-taxcalc-submenu__content__right__mtd__text">
                                                Check if you are required to use Making Tax Digital (MTD) for Income Tax.
                                            </div>
                                            <img src={mtdMain} alt="mtdMain" className="header__desktop-taxcalc-submenu__content__right__mtd__img"/>
                                            <div className="header__desktop-taxcalc-submenu__content__right__mtd__badge">New</div>
                                        </div>
                                    </Menu.Item>
                                </>
                                )}
                            </>
                            : <Menu.Item
                                key="tax-calculator"
                                onMouseEnter={() => setIsTaxCalcOpen(true)}
                                onMouseLeave={() => setIsTaxCalcOpen(false)}
                                className="header__menu-item-wrapper"
                            >
                                <div
                                    className="header__menu-item" style={{ height: "auto" }}
                                    onClick={() => isMobile && setIsTaxCalcOpen(prev => !prev)}
                                >
                                    Resources
                                </div>
                                {isTaxCalcOpen && <div className="header__desktop-taxcalc-wrapper">
                                    <div className="header__desktop-taxcalc-submenu">
                                        <div className="header__desktop-taxcalc-submenu__content">
                                            {(isSelfEmploymentTaxCalculatorEnabled || isEmploymentTaxCalculatorEnabled) && (
                                                <div className="header__desktop-taxcalc-submenu__content__left">
                                                    <div className="header__desktop-taxcalc-submenu__content__left__info">
                                                        Tax Calculators
                                                    </div>
                                                    <div className="header__desktop-taxcalc-submenu__content__left__links">
                                                        {isSelfEmploymentTaxCalculatorEnabled && (
                                                            <div
                                                                className="header__desktop-taxcalc-submenu__content__left__links__link"
                                                                onClick={() => {}}
                                                            >
                                                                <img
                                                                    src={selfEmploymentTaxCalculator}
                                                                    alt="selfEmploymentTaxCalculator"
                                                                    className="header__desktop-taxcalc-submenu__content__left__links__link__icon"
                                                                />
                                                                <div className="vertical-left">
                                                                    <div className="header__desktop-taxcalc-submenu__content__left__links__link__title">
                                                                        Self-employment Tax Calculator
                                                                    </div>
                                                                    <div className="header__desktop-taxcalc-submenu__content__left__links__link__text">
                                                                        Estimate your taxes as a sole trader
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {isEmploymentTaxCalculatorEnabled && (
                                                            <div
                                                                className="header__desktop-taxcalc-submenu__content__left__links__link"
                                                                onClick={() => {}}
                                                            >
                                                                <img
                                                                    src={employmentTaxCalculator}
                                                                    alt="employmentTaxCalculator"
                                                                    className="header__desktop-taxcalc-submenu__content__left__links__link__icon"
                                                                />
                                                                <div className="vertical-left">
                                                                    <div className="header__desktop-taxcalc-submenu__content__left__links__link__title">
                                                                        Employment Tax Calculator
                                                                    </div>
                                                                    <div className="header__desktop-taxcalc-submenu__content__left__links__link__text">
                                                                        Calculate tax from your job
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                            <div className="header__desktop-taxcalc-submenu__content__right">
                                                <div
                                                    className="header__desktop-taxcalc-submenu__content__right__mtd"
                                                    onClick={() => {
                                                        setIsTaxCalcOpen(false);
                                                        navigate(UK_ROUTES_NEW.resources);
                                                    }}
                                                >
                                                    <div className="header__desktop-taxcalc-submenu__content__right__mtd__title">
                                                        Make Tax Digital (MTD) Requirement Checker
                                                    </div>
                                                    <div className="header__desktop-taxcalc-submenu__content__right__mtd__text">
                                                        Check if you are required to use Making Tax Digital (MTD) for Income Tax.
                                                    </div>
                                                    <img src={mtdMain} alt="mtdMain" className="header__desktop-taxcalc-submenu__content__right__mtd__img"/>
                                                    <div className="header__desktop-taxcalc-submenu__content__right__mtd__badge">New</div>
                                                </div>
                                            </div>
                                        </div>
                                        <Divider/>
                                        <div className="header__desktop-taxcalc-submenu__footer">
                                            <div className="horizontal-left">
                                                <img
                                                    src={logoSmall}
                                                    alt="taxzap"
                                                    className="header__desktop-taxcalc-submenu__footer__logo"
                                                />
                                                <div className="header__desktop-taxcalc-submenu__footer__title ml6">
                                                    Ready to file your tax return?
                                                </div>
                                                <div className="header__desktop-taxcalc-submenu__footer__text ml6">
                                                    lets connect
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            </Menu.Item>
                        }

                        <Menu.Item key="pricing" className="header__menu-item-wrapper">
                            <Link to={UK_ROUTES_NEW.pricing} className="header__menu-item">
                                Pricing
                            </Link>
                        </Menu.Item>

                        <Menu.Item key="faqs" className="header__menu-item-wrapper">
                            <Link to={UK_ROUTES_NEW.faqs} className="header__menu-item">
                                FAQs
                            </Link>
                        </Menu.Item>

                        <Menu.Item key="contact" className="header__menu-item-wrapper">
                            <HashLink to={UK_ROUTES_NEW.contact} className="header__menu-item">
                                Contact
                            </HashLink>
                        </Menu.Item>
                        {!isMobile && <Menu.Item key="">
                            <div className="header__menu-country-select">
                                <img
                                    className={"pointer header__menu-flag mt15"}
                                    src={britainFlag}
                                    alt={"britain"}
                                    width={24}
                                    height={24}
                                    onClick={handleOpenCountrySelect}
                                />
                            </div>
                        </Menu.Item>}
                    </Menu>
                </Col>
                <Col
                    xs={{ span: 4, order: 3 }}
                    lg={{ span: 7, order: 3 }}
                    className={"horizontal-right"}
                >
                    {isAuth ? (
                        <Flex gap={10}>
                            <button className="shared__primary-button wAuto p16" onClick={() => navigate("/profile")}>Profile</button>
                        </Flex>
                    ) : (
                        <Flex gap={10} className="header__auth-buttons p16">
                            <button className="shared__primary-button wAuto" onClick={() => navigate("/sign-up?step=personalInfo")}>
                                    Start
                            </button>
                            <button className="shared__secondary-button wAuto" onClick={() => navigate("/auth")}>
                                    Login
                            </button>
                        </Flex>

                    )}
                </Col>
            </Row>
        </div>

        <CountrySelect
            isCountrySelectorOpened={isCountrySelectorOpened}
            handleClose={handleCloseCountrySelect}
        />
    </div>;
};

export default Header;
